import { COLOR_TAG_STYLES } from "@/config/constants";
import { IColorTag } from "@/utilities/types/ColorTag";
import cn from "@/utils/class-names";

interface ColorTagBadgeProps {
  colorTag: IColorTag;
  size?: "sm" | "md" | "lg";
  showName?: boolean;
  className?: string;
  onClick?: () => void;
  onRemove?: () => void;
}

export default function ColorTagBadge({
  colorTag,
  size = "sm",
  showName = true,
  className,
  onClick,
  onRemove,
}: ColorTagBadgeProps) {
  const styles = COLOR_TAG_STYLES[colorTag.name];

  const sizeClasses = {
    sm: "px-2 py-1 text-xs",
    md: "px-3 py-1.5 text-sm",
    lg: "px-4 py-2 text-base",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border font-medium",
        styles?.bg,
        styles?.text,
        styles?.border,
        sizeClasses[size],
        onClick && "cursor-pointer hover:opacity-80",
        className
      )}
      onClick={onClick}
    >
      {showName && <span>{colorTag.description}</span>}

      {onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className={cn(
            "ml-1 hover:bg-black/10 rounded-full p-0.5 transition-colors",
            styles.text
          )}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}
    </span>
  );
}
